import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { IOnDemandClassesWrapper } from './on-demand-classes.service.model';

@Injectable({
  providedIn: 'root'
})
export class HealthSafetyService {

  constructor(private httpClient: HttpClient, 
              private rootScopeService: RootScopeService, 
              private httpHeaderService: HttpHeadersService) {
  }

  public getEquipmentDistanceData(facilityId: string, consoleType: string): Observable<IOnDemandClassesWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const postData: any = {};
    postData.facilityId = facilityId;
    postData.consoleType = consoleType;
    const result = this.httpClient.post(environment.servicePath + '/heathsafety/equipment_distance/get', postData, { headers });
    return result as Observable<IOnDemandClassesWrapper>;

  }

  public publishEquipmentDistanceData(postData: object): Observable<IOnDemandClassesWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result= this.httpClient.post(environment.servicePath + '/heathsafety/equipment_distance', postData, { headers });
    return result as Observable<IOnDemandClassesWrapper>;
  }  

  public getExerciserCleaningData(facilityId: string, consoleType: string): Observable<IOnDemandClassesWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const postData: any = {};
    postData.facilityId = facilityId;
    postData.consoleType = consoleType;
    const result = this.httpClient.post(environment.servicePath + '/heathsafety/exerciser_cleaning/get', postData, { headers });
    return result as Observable<IOnDemandClassesWrapper>;

  }

  public publishExerciserCleaningData(postData: object): Observable<IOnDemandClassesWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result= this.httpClient.post(environment.servicePath + '/heathsafety/exerciser_cleaning', postData, { headers });
    return result as Observable<IOnDemandClassesWrapper>;
  }  

  public getStaffCleaningData(facilityId: string, consoleType: string): Observable<IOnDemandClassesWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const postData: any = {};
    postData.facilityId = facilityId;
    postData.consoleType = consoleType;
    const result = this.httpClient.post(environment.servicePath + '/heathsafety/staff_cleaning/get', postData, { headers });
    return result as Observable<IOnDemandClassesWrapper>;

  }

  public publishStaffCleaningData(postData: object): Observable<IOnDemandClassesWrapper> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result= this.httpClient.post(environment.servicePath + '/heathsafety/staff_cleaning', postData, { headers });
    return result as Observable<IOnDemandClassesWrapper>;
  }  
}




